import React, { forwardRef } from 'react';

import style from './style.module.scss';
import { Text } from 'soluble-design-system-base';
import ModalBase from '../ModalBase';
import ButtonComponent from '../ButtonComponent';

export default forwardRef(function CookieModal(
    {
        onToggle,
        onCookieAccepted,
        onCookieDeclined,
        titleText,
        bodyText,
        acceptText,
        declineText,
    },
    ref,
) {
    return (
        <ModalBase
            wrapperClassName={style.wrapperModal}
            parentRef={ref}
            onToggle={onToggle}
            size="sm"
            title={titleText}
            hideClose={false}
            headerClassName={`${style['cookies-modal-header']}`}>
            <Text className={`${style['cookie-modal-title']}`} size="sm">
                {bodyText}
            </Text>
            <div className={`${style['modal-button-container']}`}>
                <ButtonComponent
                    button={{
                        onClick: onCookieAccepted,
                        label: acceptText,
                        detached: true,
                        block: true,
                        Tag: 'button',
                    }}
                />
                <ButtonComponent
                    button={{
                        onClick: onCookieDeclined,
                        label: declineText,
                        detached: false,
                        block: true,
                        Tag: 'button',
                    }}
                    hideArrow={true}
                />
            </div>
        </ModalBase>
    );
});
